import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AppConfig } from '../../shared/config/app-config';

const SIGN_UP_ROUTE = '/onboarding-v2/profile-setup';
const PROFILE_SETUP_MFE_ROUTE = '/onboarding-v2/profile-setup-v2';

export const ProfileSetupRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const appConfig = inject(AppConfig);
    const router = inject(Router);
    const useProfileSetupRoute = appConfig.USE_PROFILE_SETUP;
    const showProfileSetupMfe = appConfig.SHOW_PROFILE_SETUP_MFE;
    const isProfileSetupMfeRoute = PROFILE_SETUP_MFE_ROUTE === state.url;
    const canRouteToProfileSetupMfe = isProfileSetupMfeRoute && showProfileSetupMfe;

    if (useProfileSetupRoute && !canRouteToProfileSetupMfe) {
        router.navigateByUrl(SIGN_UP_ROUTE);
        return false;
    }

    return true;
};
